/*
 * Makes the horizontally scrollable tables in article content reachable by
 * keyboard.
 *
 * A region that scrolls but cannot be focused is operable with a mouse or a
 * finger and with nothing else — so someone navigating by keyboard can read the
 * first two columns of a comparison table and never the rest. WCAG 2.1.1. The
 * fix is a tabindex and a name, and the browser's own scrolling does the rest.
 *
 * tabindex is only added when the table actually overflows, because a focus
 * stop on something that does not scroll is just an extra tab press on the way
 * to the next link.
 */
(function () {
  'use strict';

  function apply() {
    var tables = document.querySelectorAll('.rte table, .article-template__content table');
    for (var i = 0; i < tables.length; i++) {
      var t = tables[i];
      var overflows = t.scrollWidth > t.clientWidth + 1;

      if (!overflows) {
        if (t.dataset.nilyaScroll === '1') {
          t.removeAttribute('tabindex');
          t.removeAttribute('role');
          t.removeAttribute('aria-label');
          delete t.dataset.nilyaScroll;
        }
        continue;
      }

      if (t.dataset.nilyaScroll === '1') continue;
      t.dataset.nilyaScroll = '1';
      t.setAttribute('tabindex', '0');
      t.setAttribute('role', 'region');

      /* Named from the nearest preceding heading, so the announcement says
         which table it is rather than "region". */
      var heading = null;
      var el = t.previousElementSibling;
      while (el && !heading) {
        if (/^H[1-6]$/.test(el.tagName)) heading = el.textContent.trim();
        el = el.previousElementSibling;
      }
      t.setAttribute('aria-label', heading ? heading + ' — table, scrolls sideways' : 'Table, scrolls sideways');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  /* Rotating a phone changes whether a table overflows at all. */
  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(apply, 200);
  });
})();
